import React from "react";
import { Section, Eyebrow, Reveal } from "./shared";
import { SNAPSHOT } from "../../lib/site";

// Asymmetric capsule stat layout — not a uniform grid.
export default function Snapshot() {
  return (
    <Section id="snapshot" bg="bg-brand-paleyellow">
      <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10 lg:gap-16 items-start">
        <Reveal>
          <Eyebrow color="#E90019">The Snapshot</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[56px] leading-[0.98] mt-5">
            More Than a<br />YouTube Course
          </h2>
          <p className="text-base sm:text-lg text-brand-ink/75 mt-5 max-w-md">
            A complete 12-month implementation journey with strategy, templates, live mentorship, feedback, and accountability.
          </p>
        </Reveal>

        <div className="flex flex-col gap-3.5">
          {SNAPSHOT.map((s, i) => (
            <Reveal key={s.unit} delay={i * 0.05}>
              <div
                className={`group flex items-center gap-4 sm:gap-6 rounded-full border-2 border-brand-black bg-white px-5 sm:px-7 py-4 transition-transform duration-300 hover:-translate-y-1 ${
                  i % 2 === 1 ? "lg:ml-10" : ""
                }`}
                style={{ boxShadow: i % 2 === 0 ? "6px 8px 0 #0B31EB" : "6px 8px 0 #E90019" }}
              >
                <span className="font-display text-3xl sm:text-4xl shrink-0 min-w-[92px]" style={{ color: i % 2 === 0 ? "#0B31EB" : "#E90019" }}>
                  {s.big}
                </span>
                <div className="border-l-2 border-brand-black/10 pl-4 sm:pl-6">
                  <p className="font-bold text-sm sm:text-base">{s.unit}</p>
                  <p className="text-xs sm:text-sm text-brand-ink/70">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
